import { queryOptions } from '@tanstack/react-query';
import { ARTIFACTS_QUERY_KEY } from '@/features/artifacts/queries';
import type { Artifact } from '@/features/artifacts/types';
import { getSheet, getSheetAnnotations } from './api';

export const sheetQuery = (artifactId: string, revision?: number) =>
  queryOptions({
    queryKey: [ARTIFACTS_QUERY_KEY, artifactId, 'sheet', revision],
    queryFn: async () => (await getSheet(artifactId, revision)).data,
  });

export const sheetAnnotationsQuery = (artifact: Pick<Artifact, 'id' | 'resourceId'>) =>
  queryOptions({
    queryKey: [ARTIFACTS_QUERY_KEY, artifact.id, 'sheet-annotations', artifact.resourceId],
    queryFn: async () => (await getSheetAnnotations(artifact.id)).data,
  });
